.editor {
  overflow: hidden;
  border: 1px solid var(--ant-color-border);
  border-radius: var(--ant-border-radius);
}

.editor :global(.cm-editor) {
  height: 100%;
  font-size: 14px;
}

.editor :global(.cm-content) {
  padding: 12px 0;
}
